import PropTypes from 'prop-types'
import React from 'react'
import Cropper from 'react-easy-crop'
import { ImageManager } from 'Core/imageManager'
import { getTempLogo } from 'SRC/modules/users/Registration/selectors'
import { setLogo, setTempLogo } from 'SRC/modules/users/Registration/actions'
import { setNewLogo as setProfileLogo } from 'SRC/modules/users/Profile/actions'
import { connect } from 'react-redux'

export class LogoCropper extends React.Component {
  imageManager = new ImageManager()
  state = {
    crop: { x: 0, y: 0 },
    zoom: 1,
    pixelCrop: null
  }

  render () {
    const { setLogo, setProfileLogo, isUpdateProfile, setTempLogo, tempLogo } = this.props

    return tempLogo
      ? (
        <React.Fragment>
          <Cropper
            image={tempLogo.file}
            crop={this.state.crop}
            zoom={this.state.zoom}
            aspect={4 / 3}
            onCropChange={crop => { this.setState({ crop }) }}
            onCropComplete={pixelCrop => {
              console.log('pixelCrop', pixelCrop)
              this.setState({ pixelCrop })
            }}
            onZoomChange={zoom => { this.setState({ zoom }) }}
            style={{ containerStyle: { zIndex: 19 } }}
          />
          <button
            className='crop-button'
            onClick={async (e) => {
              e.preventDefault()
              console.log('crop', this.state.crop)
              console.log('pixelCrop', this.state.pixelCrop)

              if (isUpdateProfile) {
                const file = await this.imageManager.getCroppedImg(tempLogo.file, this.state.pixelCrop, true)
                console.log('fajl', file)
                setProfileLogo({ file, name: `${tempLogo.imageName}_${Math.round(Math.random() * 10000)}` })
                setTempLogo(null)
              } else {
                const file = await this.imageManager.getCroppedImg(tempLogo.file, this.state.pixelCrop, true)

                setLogo({ file, name: `${tempLogo.imageName}_${Math.round(Math.random() * 10000)}` })
                setTempLogo(null)
              }
            }}>ISJECI SLIKU</button>
        </React.Fragment>
      )
      : null
  }
}

const mapStateToProps = state => ({
  tempLogo: getTempLogo(state)
})

export default connect(mapStateToProps, {
  setTempLogo,
  setLogo,
  setProfileLogo
})(LogoCropper)

LogoCropper.propTypes = {
  tempLogo: PropTypes.shape({
    imageName: PropTypes.string,
    file: PropTypes.any
  }).isRequired,
  isUpdateProfile: PropTypes.bool.isRequired,
  setTempLogo: PropTypes.func.isRequired,
  setLogo: PropTypes.func.isRequired,
  setProfileLogo: PropTypes.func.isRequired
}

LogoCropper.defaultProps = {
  isUpdateProfile: false
}
